import { render, staticRenderFns } from "./PerguntasIcmsCargaLiquida.vue?vue&type=template&id=25a7a1cd&scoped=true&"
import script from "./PerguntasIcmsCargaLiquida.vue?vue&type=script&lang=js&"
export * from "./PerguntasIcmsCargaLiquida.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasIcmsCargaLiquida.vue?vue&type=style&index=0&id=25a7a1cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7a1cd",
  null
  
)

export default component.exports